import { isUserLoggedIn } from '@/redux/modules/account/user/user.selectors';
import { fetchBidLimitBalanceIfNeeded } from '@/redux/modules/bidLimit/bidLimit.actions';
import { fetchCatalogsIfNeeded } from '@/redux/modules/catalog/catalogs/catalog.actions';
import { getCatalogSellerId } from '@/redux/modules/catalog/catalogs/catalog.selectors';
import { fetchCatalogDetailsIfNeeded } from '@/redux/modules/catalog/detail/catalogDetail.actions';
import { fetchSellersDetailsIfNeeded } from '@/redux/modules/sellerDetail';
import { fetchSellerFollowerCountIfNeeded } from '@/redux/modules/sellerFollowerCount';
import { fetchSellerRatingSummaryByIdIfNeeded } from '@/redux/modules/sellerRatings';
import { fetchTopSellersIfNeeded } from '@/redux/modules/topRatedSellers';
import { DataLoaderParams } from '@/types/DataLoaderParams';
import { getNotFoundUrl, toQueryString } from '@/utils/urls';

const reviewPageData = async ({ location, match, redirect, store }: DataLoaderParams) => {
    const { params } = match;
    const { dispatch } = store;
    const catalogId = params.catalogId;

    const userIsLoggedIn = isUserLoggedIn(store.getState());

    // Prompt user to login and return to this page
    if (!userIsLoggedIn) {
        return redirect(
            `/loginRedirect?${toQueryString({
                redirectTo: `${location.pathname}${location.search || ''}`,
            })}`
        );
    }

    await Promise.all([
        dispatch(fetchBidLimitBalanceIfNeeded({ catalogId })),
        dispatch(fetchCatalogDetailsIfNeeded([catalogId])),
        dispatch(fetchTopSellersIfNeeded()),
        dispatch(fetchCatalogsIfNeeded({ catalogIds: [catalogId] })),
    ]);

    const sellerId = getCatalogSellerId(store.getState(), catalogId);

    if (!sellerId) {
        return redirect(getNotFoundUrl());
    }

    await Promise.all([
        dispatch(fetchSellersDetailsIfNeeded([sellerId])),
        dispatch(fetchSellerFollowerCountIfNeeded([sellerId])),
        dispatch(fetchSellerRatingSummaryByIdIfNeeded(sellerId)),
    ]);
};

export default reviewPageData;
